/* eslint-disable */
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { RiUserSettingsLine } from "react-icons/ri";
// chakra imports
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  Collapse,
  Icon,
} from "@chakra-ui/react";

import Users from "views/admin/Users";
import role from "views/admin/Role";
import settings from "views/admin/setting";
import AiDashboard from "views/admin/AiDashboard";
import AiSetting from "views/AiSetting";
import Client from "views/Clients";
import Documents from "views/Documents/index";
import Feedback from "views/Feedback/index";
import Faq from "views/Faq/index";
import Chat from "views/Chat/index";

import {
  MdSettings,
  MdPermContactCalendar,
  MdArrowDropDown,
  MdArrowDropUp,
  MdHome,
  MdSystemUpdate,
} from "react-icons/md";

import { useTranslation } from "react-i18next";
import { create } from "ol/transform";
import { IoDocumentText } from "react-icons/io5";
import { VscFeedback } from "react-icons/vsc";
import { TbZoomQuestion } from "react-icons/tb";
import { IoMdChatbubbles } from "react-icons/io";

// ⭐⭐⭐ BADGE IMPORT ⭐⭐⭐
import { useUnseenOrders } from "contexts/UnseenOrdersContext";
import AppVersions from "views/admin/App Versions";

export function SidebarLinks(props) {
  let location = useLocation();

  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.600", "brand.400");
  let textColor = useColorModeValue("secondaryGray.600", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { t } = useTranslation();
  const { routes } = props;

  const { unseenOrders } = useUnseenOrders();
  const isOrdersPage = location.pathname.startsWith("/admin/orders");

  const aiRoutes = [
    {
      name: "AI Dashboard",
      layout: "/admin",
      path: "/Ai Dashboard",
      icon: (
        <Icon as={MdHome} width="20px" height="20px" color="inherit" />
      ),
      component: AiDashboard,
    },
    {
      name: "Clients",
      layout: "/admin",
      path: "/clients",
      icon: (
        <Icon
          as={MdPermContactCalendar}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: Client,
    },
    {
      name: "Documents",
      layout: "/admin",
      path: "/documents",
      icon: (
        <Icon
          as={IoDocumentText}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: Documents,
    },
    {
      name: "Feedback",
      layout: "/admin",
      path: "/feedback",
      icon: (
        <Icon
          as={VscFeedback}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: Feedback,
    },
    {
      name: "Faq",
      layout: "/admin",
      path: "/faq",
      icon: (
        <Icon
          as={TbZoomQuestion}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: Faq,
    },
    {
      name: "Chat",
      layout: "/admin",
      path: "/chat",
      icon: (
        <Icon
          as={IoMdChatbubbles}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: Chat,
    },
    {
      name: "AiSetting",
      layout: "/admin",
      path: "/aisetting",
      icon: (
        <Icon
          as={MdSettings}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: AiSetting,
    },
  ];

  const [clickedLinkIndex, setClickedLinkIndex] = useState(null);
  const [hasSettingsPermission, setHasSettingsPermission] =
    useState(false);
  const [roleId, setRoleID] = useState("");

  useEffect(() => {
    const userPermissions = JSON.parse(
      sessionStorage.getItem("userPermissions")
    );
    const roleId = JSON.parse(sessionStorage.getItem("role_id"));
    setRoleID(roleId);

    if (userPermissions && userPermissions.includes("settings")) {
      setHasSettingsPermission(true);
    } else {
      setHasSettingsPermission(true);
    }
  }, []);

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const renderDropdownLinks = () => {
    const dropdownLinks = [
      {
        name: "Users",
        layout: "/admin",
        path: "/users",
        icon: (
          <Icon
            as={MdPermContactCalendar}
            width="20px"
            height="20px"
            color="inherit"
          />
        ),
        component: Users,
      },
      {
        name: "Roles",
        layout: "/admin",
        path: "/roles",
        icon: (
          <Icon
            as={RiUserSettingsLine}
            width="20px"
            height="20px"
            color="inherit"
          />
        ),
        component: role,
      },
      
    ];

    return dropdownLinks.map((link, index) => (
      <NavLink
        key={index}
        to={link.layout + link.path}
        onClick={() => setClickedLinkIndex(index)}
      >
        <Box>
          <HStack
            spacing={activeRoute(link.path) ? "22px" : "26px"}
            py="5px"
            ps="10px"
          >
            <Flex w="100%" alignItems="center" justifyContent="center">
              <Box
                color={
                  activeRoute(link.path) ? activeIcon : textColor
                }
                me="18px"
              >
                {link.icon}
              </Box>
              <Text
                me="auto"
                color={
                  activeRoute(link.path)
                    ? activeColor
                    : textColor
                }
                fontWeight={
                  activeRoute(link.path) ? "bold" : "normal"
                }
              >
                {t(link.name)}
              </Text>
            </Flex>
            <Box
              h="36px"
              w="4px"
              bg={
                activeRoute(link.path)
                  ? brandColor
                  : "transparent"
              }
              borderRadius="5px"
            />
          </HStack>
        </Box>
      </NavLink>
    ));
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (roleId == 1) {
        if (
          route.name !== "Users" &&
          
          route.name !== "Roles" &&
          route.name !== "Sign In" &&
          route.name !== "Profile" 
        ) {
          if (
            route.layout === "/admin" ||
            route.layout === "/auth"
          ) {
            const isActive = activeRoute(route.path);

            return (
              <NavLink key={index} to={route.layout + route.path}>
                <Box>
                  <HStack
                    spacing={isActive ? "22px" : "26px"}
                    py="5px"
                    ps="10px"
                  >
                    <Flex
                      w="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        color={isActive ? activeIcon : textColor}
                        me="18px"
                      >
                        {route.icon}
                      </Box>

                      {/* ⭐⭐ LABEL + BADGE ⭐⭐ */}
                      <Text
                        me="auto"
                        color={isActive ? activeColor : textColor}
                        fontWeight={isActive ? "bold" : "normal"}
                        display="flex"
                        alignItems="center"
                        gap="6px"
                      >
                        {t(route.name)}

                        {/* 🔵 SHOW BADGE ON ORDERS */}
                        {route.name === "Orders" &&
                          unseenOrders > 0 &&
                          !isOrdersPage && (
                            <Box
                              bg="red.500"
                              color="white"
                              px="6px"
                              py="2px"
                              borderRadius="full"
                              fontSize="11px"
                              minW="18px"
                              textAlign="center"
                            >
                              {unseenOrders}
                            </Box>
                          )}
                      </Text>
                    </Flex>

                    <Box
                      h="36px"
                      w="4px"
                      bg={isActive ? brandColor : "transparent"}
                      borderRadius="5px"
                    />
                  </HStack>
                </Box>
              </NavLink>
            );
          }
        }
      } else {
        if (
          route.layout === "/admin" ||
          route.layout === "/auth"
        ) {
          const isActive = activeRoute(route.path);

          return (
            <NavLink key={index} to={route.layout + route.path}>
              <Box>
                <HStack
                  spacing={isActive ? "22px" : "26px"}
                  py="5px"
                  ps="10px"
                >
                  <Flex
                    w="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      color={isActive ? activeIcon : textColor}
                      me="18px"
                    >
                      {route.icon}
                    </Box>

                    {/* ⭐⭐ LABEL + BADGE ⭐⭐ */}
                    <Text
                      me="auto"
                      color={isActive ? activeColor : textColor}
                      fontWeight={isActive ? "bold" : "normal"}
                      display="flex"
                      alignItems="center"
                      gap="6px"
                    >
                      {t(route.name)}

                      {/* 🔵 BADGE */}
                      {route.name === "Orders" &&
                        unseenOrders > 0 &&
                        !isOrdersPage && (
                          <Box
                            bg="red.500"
                            color="white"
                            px="6px"
                            py="2px"
                            borderRadius="full"
                            fontSize="11px"
                            minW="18px"
                            textAlign="center"
                          >
                            {unseenOrders}
                          </Box>
                        )}
                    </Text>
                  </Flex>

                  <Box
                    h="36px"
                    w="4px"
                    bg={isActive ? brandColor : "transparent"}
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            </NavLink>
          );
        }
      }
    });
  };


  return (
    <>
      {createLinks(routes)}

      {hasSettingsPermission && (
        <>
          <Box>
            <HStack
              spacing="26px"
              cursor="pointer"
              onClick={toggleDropdown}
              py="5px"
              ps="10px"
            >
              <Flex w="100%" alignItems="center">
                <Box color={textColor} me="18px">
                  <Icon as={MdSettings} boxSize={5} />
                </Box>
                <Text me="auto" color={textColor} fontWeight="normal">
                  {t("Settings")}
                </Text>
                <Box color={textColor} pt="1">
                  <Icon
                    as={isDropdownOpen ? MdArrowDropUp : MdArrowDropDown}
                    boxSize={8}
                  />
                </Box>
              </Flex>
            </HStack>
          </Box>

          <Collapse in={isDropdownOpen}>
            <Box ml="30px">{renderDropdownLinks()}</Box>
          </Collapse>
        </>
      )}
    </>
  );
}

export default SidebarLinks;
